module.exports = __webpack_public_path__ + "static/media/report.f244dbd1.svg";